module.exports = __webpack_public_path__ + "static/media/merchandising.fe693a95.svg";